import React, { useState } from 'react';
import { Outlet, Link } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import { Menu, X } from 'lucide-react';

export const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* TopBar with hamburger */}
      <TopBar onMenuClick={() => setSidebarOpen(true)} />

      <main className="md:ml-64 mt-16 p-4 md:p-6">
        <Outlet />
      </main>

      {/* Footer */}
      <div className="md:ml-64 py-3 border-t border-gray-100 flex flex-wrap items-center justify-between px-4 md:px-6">
        <span className="text-[10px] text-gray-400">
          © {new Date().getFullYear()} Powered by <span className="font-medium text-gray-500">Samruddhi Technologies</span>
        </span>
        <div className="flex gap-3 text-[10px] text-gray-400">
          <Link to="/support" className="hover:text-blue-500">Support</Link>
          <Link to="/terms" className="hover:text-blue-500">Terms</Link>
          <Link to="/privacy" className="hover:text-blue-500">Privacy</Link>
          <Link to="/refund-policy" className="hover:text-blue-500">Refund Policy</Link>
          <Link to="/about" className="hover:text-blue-500">About</Link>
        </div>
      </div>
    </div>
  );
};

export default Layout;
